import { createUser } from "../../../../../api-requests/users";
import { UserForm } from "../UserForm/UserForm";

export default function CreateUser({
  refreshUsers,
}: {
  refreshUsers: () => void;
}) {
  return (
    <UserForm
      action="create"
      refreshUsers={refreshUsers}
      save={createUser}
      successMessage="Utilisateur ajouté"
      errorMessage="Echec ajout utilisateur"
    />
  );
}
